import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, Navigate } from "react-router-dom";
import Calling from "../../api/Calling";
import { TextField, Button, InputAdornment, CircularProgress } from "@mui/material";
import { KeyRound, ShieldCheck } from "lucide-react";
import AuthShell, { darkFieldSx, authButtonSx } from "./AuthShell";

export default function LoginOtp({ onLogin }) {
    const [loader, setLoader] = useState(false);
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // 🔒 Block direct access — must come from the login step (temp token set)
    if (!localStorage.getItem('token')) {
        return <Navigate to="/admin/panel/login" replace />;
    }

    const validate = () => {
        if (!otp.trim()) return "OTP is required";
        if (!/^\d{6}$/.test(otp.trim())) return "Enter the 6-digit code";
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const v = validate();
        if (v) { setError(v); return; }
        setError("");
        setLoader(true);
        const body = {
            otp
        }
        try {
            const resp = await Calling.LoginOtp(body); // Example function, replace with actual
            const { status, message, token } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                onLogin(true);

                localStorage.removeItem('token');
                localStorage.setItem('admin_trucaller', token);
                navigate("/"); // Replace with the actual route
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
        // Replace with your OTP verification logic

    };

    return (
        <>
            <title>OTP Verification</title>

            <AuthShell
                icon={<ShieldCheck size={30} />}
                title="OTP Verification"
                subtitle="Enter the 6-digit code sent to your email"
            >
                <form onSubmit={handleSubmit} noValidate className="flex flex-col gap-4">
                    <TextField
                        label="Enter OTP"
                        type="text"
                        value={otp}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                            setOtp(val);
                            if (error) setError("");
                        }}
                        required
                        fullWidth
                        error={!!error}
                        helperText={error}
                        sx={darkFieldSx}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <KeyRound size={18} color="rgba(255,255,255,0.55)" />
                                    </InputAdornment>
                                ),
                            },
                            htmlInput: { maxLength: 6, inputMode: "numeric", style: { letterSpacing: "0.4em" } },
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disableElevation
                        disabled={loader}
                        sx={authButtonSx}
                        startIcon={loader ? <CircularProgress size={18} color="inherit" /> : <ShieldCheck size={18} />}
                    >
                        {loader ? "Verifying..." : "Verify OTP"}
                    </Button>
                </form>
            </AuthShell>
        </>
    );
}
